import React from 'react';

import Container from './Container';
import PencilIcon from './PencilIcon';
import { inject } from 'mobx-react';

export default inject('page')(({ page }) => (
  <Container onClick={page.openModal} title="Edit address">
    <PencilIcon />
  </Container>
));
